import { taskDetailModal as taskDetailModalDiagram} from '@process-advisor/process-miner/processMiner/processMiner';

export type TaskDetailProps = {
    param?: string,
};

export const taskDetail = ({ param}: TaskDetailProps) => {
    taskDetailModalDiagram();
};


